module.exports = __webpack_public_path__ + "media/images/idea-a2df6fc3.png";